import { render, staticRenderFns } from "./AnalysisReferenceDetail.vue?vue&type=template&id=81d9c02c&scoped=true"
import script from "./AnalysisReferenceDetail.vue?vue&type=script&lang=js"
export * from "./AnalysisReferenceDetail.vue?vue&type=script&lang=js"
import style0 from "./AnalysisReferenceDetail.vue?vue&type=style&index=0&id=81d9c02c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d9c02c",
  null
  
)

export default component.exports